import { gql } from '@apollo/client';

// Test mutation to verify basic post creation
export const TEST_CREATE_POST = gql`
  mutation TestCreatePost($title: String!) {
    createPost(
      input: {
        title: $title
        status: DRAFT
        contentType: POST
      }
    ) {
      post {
        databaseId
        title
        status
      }
    }
  }
`;

// Create a disability hack post with DRAFT status
export const CREATE_DISABILITY_HACK = gql`
  mutation CreateDisabilityHackSubmission($input: CreateDisabilityHackInput!) {
    createDisabilityHack(input: $input) {
      disabilityHack {
        id
        title
        status
        databaseId
      }
    }
  }
`;

// Update the custom fields for a disability hack using the correct GraphQL field names
export const UPDATE_HACK_FIELDS = gql`
  mutation UpdateHackFields(
    $id: ID!
    $title: String
    $platform: String
    $videoUrl: String
    $summary: String
    $hackDescription: String
    $hackCategory: String
    $otKeywords: String
    $source: String
    $userTested: String
    $otUsefulnessRating: Int
    $reviewedBy: String
    $difficultyLevel: String
  ) {
    updateDisabilityHack(
      input: {
        id: $id
        disabilityHacksImport: {
          title: $title
          platform: $platform
          videoUrl: $videoUrl
          summary: $summary
          hackDescription: $hackDescription
          hackCategory: $hackCategory
          otKeywords: $otKeywords
          source: $source
          userTested: $userTested
          otUsefulnessRating: $otUsefulnessRating
          reviewedBy: $reviewedBy
          difficultyLevel: $difficultyLevel
        }
      }
    ) {
      disabilityHack {
        databaseId
        title
        disabilityHacksImport {
          title
          platform
          videoUrl
          summary
          hackDescription
          hackCategory
          otKeywords
          source
          userTested
          otUsefulnessRating
          reviewedBy
          difficultyLevel
        }
      }
    }
  }
`;

// Set the featured image for a post
export const SET_FEATURED_IMAGE = gql`
  mutation SetFeaturedImage($postId: ID!, $mediaId: ID!) {
    updatePost(
      input: {
        id: $postId
        featuredImageId: $mediaId
      }
    ) {
      post {
        databaseId
        featuredImage {
          node {
            id
            sourceUrl
          }
        }
      }
    }
  }
`;

// Create a new media item - removed Upload scalar because we'll use REST API for uploads
export const CREATE_MEDIA_ITEM = gql`
  mutation CreateMediaItem($title: String, $altText: String) {
    createMediaItem(
      input: {
        title: $title
        altText: $altText
        status: PUBLISH
      }
    ) {
      mediaItem {
        id
        databaseId
        sourceUrl
        altText
      }
    }
  }
`; 